import { render, staticRenderFns } from "./assetData.vue?vue&type=template&id=59895bfe"
import script from "./assetData.vue?vue&type=script&lang=js"
export * from "./assetData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports